import ReactDOM from 'react-dom/client'
import CARPREG2Patients from './surveys/carpreg2patients.jsx'
import CARPREG2CareProviders from './surveys/carpreg2careproviders.jsx'
import MWHO from './surveys/mwho.jsx'

function App() {
  const surveyType = ccbSurveyData?.surveyType

  if (surveyType === 'c2p') {
    return <CARPREG2Patients />
  }

  if (surveyType === 'c2cp') {
    return <CARPREG2CareProviders />
  }

  if (surveyType === 'mwho') {
    console.log('Rendering mWHO survey')
    return <MWHO />
  }
}

const root = ReactDOM.createRoot(document.getElementById('surveyAppRoot'))
root.render(<App />)